import { Redirect } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom-v5-compat';

import { FulfillmentsPage } from './fulfillments-page';
import style from './fulfilments-page.module.less';
import { SetupPage } from './overview';
import Page from '../../components/page';
import {
  useIsFulfillmentsTabVisible,
  useSellerShipStationFulfillmentProvider,
} from '../../hooks/use-shipstation-fulfillment-whitelabel-enabled';
import { DEFAULT_ORDERS_PAGE_URL } from '../../services/user-permission-service';

export const FulfillmentsWrapperPage = () => {
  const isShipStationFulfillmentWhitelabelEnabled = useIsFulfillmentsTabVisible();
  const sellerShipStationFulfillmentProvider = useSellerShipStationFulfillmentProvider();

  if (!isShipStationFulfillmentWhitelabelEnabled) {
    return <Redirect to={DEFAULT_ORDERS_PAGE_URL} />;
  }

  if (!sellerShipStationFulfillmentProvider) {
    return (
      <div className={style['fulfillments-page-wrapper']}>
        <Page>
          <Routes>
            <Route element={<SetupPage />} path='/' />
          </Routes>
        </Page>
      </div>
    );
  }

  return <FulfillmentsPage />;
};
